import { Body, colors } from '@spritz-finance/ui'
import styled from 'styled-components'

export const BadgeContainer = styled.div<{
    $visible: boolean
    $background?: string
}>`
    display: inline-flex;
    background-color: ${({ $background }) => $background ?? colors.ltAqua[25]};
    border-radius: 20px;
    padding: 4px 8px;
    align-items: center;
    transition: opacity 0.2s ease-in-out;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
`

const NewBadgeWrapper = styled(BadgeContainer)`
    height: 20px;
    box-sizing: border-box;
`

export const NewBadge = () => {
    return (
        <NewBadgeWrapper $visible={true} $background={colors.chartreuse[100]}>
            <Body.SmBold size={10}>New!</Body.SmBold>
        </NewBadgeWrapper>
    )
}
